import Menu from "./Menu";



function PageHeader() {
    return (
        <div className="grid justify-items-center  top-0 w-full ">
            <a href="/">
                <div className="mt-4 text-5xl  text-gray-900 rounded-lg  max-w-3xl " >
                    <img src="/sjbanner_inv_nobg.png" alt="Steven Jay" />
                </div>
            </a>

            <div className="mt-2 text-sm  text-gray-900 text-center">The Art of Steven Jay Athanas</div>
            <Menu />
        </div>
    )
}
export default PageHeader;